// extracted by mini-css-extract-plugin
export var checkbox = "_75-0";
export var circle = "_75-3";
export var horizontalContainer = "_75-7";
export var sm = "_75-5";
export var switch0 = "_75-2";
export var switchDisabled = "_75-8";
export var switchEnabled = "_75-1";
export var textSwitchContainer = "_75-9";
export var textSwitchOption = "_75-a";
export var textSwitchOptionSelected = "_75-b";
export var verticalContainer = "_75-6";
export var xs = "_75-4";